import { Grid } from "@mui/material";
import React from "react";

function Missing() {
  return (
    <Grid
      container
      justifyContent={"center"}
      direction={"column"}
      alignItems={"center"}
      height={'100vh'}
    >
      <Grid item>
        <h4> You need sufficient permission to access!</h4>
      </Grid>
    </Grid>
  );
}

export default Missing;
